module.exports = __webpack_public_path__ + "img/inactiveicon-network.1103f518.svg";